module.exports = __webpack_public_path__ + "static/media/logo-lak-thueringen_3x.d69e9903.png";